import { collection, addDoc, setDoc, doc, query, where, getDocs } from "firebase/firestore";
import { db } from "../../config/fbConfig"; // Assure-toi que db = getFirestore(firebaseApp)

export const connexion = (email, numTel) => {
  return async (dispatch) => {
    try {
      await addDoc(collection(db, "utilisateurs"), {
        email: email,
        numTel: numTel,
        ip: window.localStorage.ip,
        UUID: window.localStorage.UUID,
        dateCreation: new Date()
      });

      window.localStorage.removeItem("ip");
      dispatch({ type: "CONNEXION_REUSSI" });
      window.location.assign("/menu-rapport");
    } catch (err) {
      dispatch({ type: "ERREUR_CONNEXION", err });
    }
  };
};

export const stateCodeToFirestore = (email, code) => {
  return async (dispatch) => {
    try {
      const q = query(collection(db, "GUID"), where("email", "==", window.localStorage.email));
      const utilisateurSnapshot = await getDocs(q);
      const date = new Date();
      const lifetime = date.setDate(date.getDate() + 1);

      if (!utilisateurSnapshot.empty) {
        utilisateurSnapshot.forEach(async (docSnap) => {
          if (docSnap.id) {
            await setDoc(doc(db, "GUID", docSnap.id), {
              email: email,
              lifetime: lifetime,
              code: code
            });
          }
        });
      } else {
        await addDoc(collection(db, "GUID"), {
          email: email,
          lifetime: lifetime,
          code: code
        });
      }

      dispatch({ type: "STATE_CODE_TO_FIRESTORE" });
    } catch (err) {
      console.error("Erreur stateCodeToFirestore:", err);
    }
  };
};

// Les autres actions simples restent inchangées
export const isAuthentified = (auth) => (dispatch) => {
  dispatch({ type: "AUTH_STATUS", auth: auth });
};

export const wrongCode = () => (dispatch) => {
  dispatch({ type: "MAUVAIS_CODE" });
};

export const expired = () => (dispatch) => {
  dispatch({ type: "CODE_EXPIRE" });
};

export const wrongEmail = () => (dispatch) => {
  dispatch({ type: "MAUVAISE_INFO_EMAIL" });
};

export const wrongNumber = () => (dispatch) => {
  dispatch({ type: "MAUVAISE_INFO_NUM" });
};

export const aucunDroit = () => (dispatch) => {
  dispatch({ type: "AUCUN_DROIT" });
};

export const resetAuthState = () => (dispatch) => {
  dispatch({ type: "RESET_AUTH_STATE" });
};
